import {Component, OnInit} from '@angular/core';
import {JobsDataService} from '../../../../modules/jobs/jobs-data.service';

@Component({
    selector: 'app-my-applications',
    templateUrl: './view-my-applications.component.html',
    styleUrls: ['./view-my-applications.component.scss']
})

export class ViewMyApplicationsComponent implements OnInit {
    applications: any = [];
    interviews: any = [];
    applicationsLoaded = false;
    showAllInterviews = false;
    showAllApps = true;
    job:any;

    constructor(private jobsDataService: JobsDataService) {
    }

    ngOnInit() {
        this.jobsDataService.getMyApplications().subscribe(res => {
            this.applications = res;
            console.log('app',this.applications);

            this.applications.forEach((singleApplication, index) => {
                if (singleApplication.statusApplication.hasInterviewDate) {
                    this.interviews.push(singleApplication);
                }
                this.jobsDataService.getCurrentJob(singleApplication.jobId).subscribe((job:any)=>{
                    console.log('job pt aplicare',job);
                    this.job=job;
                    this.applications[index].companyName = this.job.companyName;
                    this.applications[index].applicationDetail.logo = job.photoPath
                })
            })
            this.applicationsLoaded = true;
        });
    }

    displayApps(arg) {
        if (arg === 'all') {
            this.showAllInterviews = false;
            this.showAllApps = true;
        } else {
            this.showAllInterviews = true;
            this.showAllApps = false;
        }
    }
}
